
function pxToRem(asked, base = 16) {
  const rem = (asked / base).toFixed(2);
  return `${rem}rem`;
}

module.exports = {
  '4.5': pxToRem(18),
  '5.5': pxToRem(22),
  '7.5': pxToRem(30),
  '13': pxToRem(52),
  '17.5': pxToRem(70),
  'gutter': '32px',
  'gutter--mobile': '12px',
  'section': '60px',
  'section--mobile': '20px',
}